import { ICartItemV2 } from "@faire/web-api/faire/carts/ICartItemV2";
import { useContext } from "react";

import { BrandPageCartStateContext } from "../../contexts/BrandPageCartStateContext";

export interface AddPendingCartItemFunction {
  (item: ICartItemV2): void;
}

export const useAddPendingCartItem = (): AddPendingCartItemFunction => {
  const { brandCartViewState } = useContext(BrandPageCartStateContext);
  return brandCartViewState.setPendingCartItems;
};

export const useClearPendingCartItems = (): (() => void) => {
  const { brandCartViewState } = useContext(BrandPageCartStateContext);
  return brandCartViewState.clearPendingCartItems;
};
